import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import { TagsListType } from '../../../store/tags/tagsTyping'

import paths from '../../../paths'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import './tagsBlock.sass'
import { createLink } from '../TagsUtils'
import { setCurrentSlug, setCurrentTag } from '../../../store/tags/tagsSlice'
import { useDispatch } from 'react-redux'

interface Props {
    tags: TagsListType[]
    chosenTag: string
    setIsPopupOpen: React.Dispatch<boolean>
}

const TagsBlock: React.FunctionComponent<Props> = ({ tags, chosenTag, setIsPopupOpen }: Props) => {
    const location = useLocation()
    const dispatch = useDispatch()

    return (
        <div className="tagsBlock">
            {tags.map((item) => (
                <Link
                    key={item.id}
                    className={item.text == chosenTag ? 'link chosen' : 'link'}
                    onClick={() => {
                        setIsPopupOpen(false)
                        dispatch(setCurrentSlug(item.slug))
                        dispatch(setCurrentTag(item.text))
                    }}
                    to={createLocalizedPath(createLink(location.pathname).toPath({ tag: item.slug }))}
                >
                    {item.text}
                </Link>
            ))}
        </div>
    )
}

export default TagsBlock
